import { createAuthClient } from 'better-auth/react';

const VITE_API_URL = import.meta.env.VITE_API_URL;

export const authClient = createAuthClient({
  baseURL: `${VITE_API_URL}/api/auth`,
  fetchOptions: {
    credentials: 'include',
  },
});

export const { signIn, signUp, signOut, useSession, getSession } = authClient;
